import { useStateValue } from "../../StateManagement";
import * as actionTypes from "./actionTypes";

export const useActionCreator = () => {
  const { dispatch } = useStateValue();

  return {
    showContactUsComponent: () => {
      dispatch({
        type: actionTypes.SHOW_CONTACT_US_COMPONENT,
      });
    },

    hideContactUsComponent: () => {
      dispatch({
        type: actionTypes.HIDE_CONTACT_US_COMPONENT,
      });
    },
  };
};
